// extracted by mini-css-extract-plugin
export default {"number":"cReYd"};